import { useEffect } from "react";
import useStorageState from "../useStorageState";

export default function useLocation(
  locationClient,
  isFocused = true,
  storage = null,
) {
  const [location, saveLocation, setLocation] = useStorageState(
    storage,
    "location",
    null,
  );

  const getLocation = async () => {
    try {
      const response = await locationClient.getLocation(true);
      saveLocation(response.data);
      return true;
    } catch (error) {
      console.warn('Error in "getLocation"', error, error.stack);
      return false;
    }
  };

  const loadData = getLocation;

  const clearData = () => {
    setLocation(null);
  };

  const initData = loadData;

  useEffect(() => {
    if (isFocused) initData();
    else clearData();
  }, [isFocused]);

  return {
    location,
    data: { update: loadData, clear: clearData, init: initData },
  };
}
